export enum VisitorRoleEnum {
  FamilyMember = "familyMember",
  Resident = "resident",
  Staff = "staff"
}